import { withInstall, withNoopInstall } from '@zoryn/utils'
import Collapse from './src/collapse.vue'
import CollapseItem from './src/collapse-item.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCollapse: SFCWithInstall<typeof Collapse> & {
  CollapseItem: typeof CollapseItem
} = withInstall(Collapse, {
  CollapseItem,
})
export default ZCollapse
export const ZCollapseItem: SFCWithInstall<typeof CollapseItem> =
  withNoopInstall(CollapseItem)

export * from './src/collapse'
export * from './src/collapse-item'
export * from './src/constants'
export type { CollapseInstance, CollapseItemInstance } from './src/instance'
